
import React, { useState } from 'react';
import './SSS.css';


import ekumesIcon from '../assets/icons/ekumes.png';
import performansIcon from '../assets/icons/performans.png';
import maliyetIcon from '../assets/icons/maliyet.png';
import sensorIcon from '../assets/icons/sensor.png';
import uyariIcon from '../assets/icons/uyari.png';
import kumesLimitIcon from '../assets/icons/kumesLimit.png';
import ucretIcon from '../assets/icons/ucret.png';
import tanimlamaIcon from '../assets/icons/tanimlama.png';
import resim1 from '../assets/icons/Resim1.png';
import resim2 from '../assets/icons/Resim2.png';
import resim3 from '../assets/icons/Resim3.jpg';
import resim4 from '../assets/icons/Resim4.jpg';
import resim5 from '../assets/icons/Resim5.jpg';
import { Style } from '@mui/icons-material';

const SSS = () => {
  const [activeSection, setActiveSection] = useState('ekumes');

  const sections = [
    {
      id: 'ekumes',
      title: 'E-Kümes Nedir?',
      icon: ekumesIcon,
content: 'Gelişen ve değişen dünyada akıllı teknolojilerin kullanımı her geçen gün daha da artmaktadır. Artan nüfus ve gıda ihtiyacı karşısında kanatlı hayvanlara olan talep de hızla büyümektedir. Bu durum aynı akıllı tarım sistemleri gibi teknolojik sistemlerle donatılmış kapalı kümes hayvancılığının da gelişmesine imkân tanımıştır. Kanatlı hayvanların sağlıklı ve verimli büyüyebilmesi için kümesler çok önemlidir. Çünkü hayvanların yaşamalarını sürdürdükleri alanlar buralardır. Kümes hayvanlarının optimal şekilde büyümesini sağlayabilmek için kümes içi parametrelerin düzenli olarak kontrol edilmesi ve yönetilmesi gerekmektedir. Kümeslerde sıcaklık, havalandırma, nem gibi değişkenlerin kontrol edilmesi hayvan hastalıklarının ve hayvan ölümlerinin önlenmesinde de oldukça büyük önem arz etmektedir. Tüm bu parametreler genellikle çiftçiler tarafından manuel olarak ayarlanmaya çalışılmaktadır. eKümes elektronik kümes takip sistemi; kümes ortamının optimal koşullarının izlenmesini sağlamayı amaçlamaktadır. Kümeslerden anlık sensör verilerini toplamak, toplanan verileri internet üzerinden sunucu bilgisayar üzerine kaydetmek, sunucu üzerindeki verilerin yetki dahilinde analiz edilmesi, sorunların anlık izlenebilmesi, uyarı mekanizmalarının kurulması, tek merkez üzerinden tüm üreticilerin izlenmesini sağlayarak bakım kusurlarının ortadan kaldırılması hedeflenmiştir.'
    },
    {
      id: 'gelistirilme',
      title: 'E-Kümes Sistemi Nasıl Geliştirildi?',
      icon: ekumesIcon,
content: 'eKümes Bolu Abant İzzet Baysal Üniversitesi Ziraat Fakültesi Kanatlı Hayvan Yetiştiriciliği Bölümü ile firmamızın yaptığı ortak çalışma neticesinde geliştirilmiştir. eKümes, tamamı açık kaynak kodlu yazılımlar ile Türk Yazılım Mühendisleri ile üretilmiştir. Yapay zeka değerlendirmelerinde R Server üzerinde çalışan regresyon analizleri kullanılmaktadır. Öğrenme dataseti Bolu Yöresinde üretim yapan 30 kümesin 2 yılık üretim dönemindeki sensör verileri ile oluşturulmuştur. Projenin finansmanında KOSGEB AR-GE desteği kullanılmıştır. Kullanılan teknoloji Beyaz et veya yumurta üreticiliğinde kullanılan kümeslerden toplanan sensör verilerinin yapay zeka algoritması ile işlenmesi ve üretim performansını arttıran sistem ve metodun geliştirmesi adıyla patentlenmiştir.'
    },
    {
      id: 'performans',
      title: 'Performans Puanı Hesaplama',
      icon: performansIcon,
      content: `
        <div class="performance-content">
          <p>1. Ölüm oranı; Yetiştiricilere teslim edilen civciv sayısından kesimhaneye teslim edilen piliç sayısı düşülerek üretim süresince ölen hayvanların sayısı tespit edilmekte ve teslim edilen civciv sayısına oranlanarak ölüm oranı tespit edilmektedir.</p>
          
          <p>2. Ortalama ağırlık; Kesimhaneye teslim edilen hayvanların toplam ağırlığı hayvan sayısına bölünerek elde edilmektedir.</p>
          
          <p>3. Yem dönüşüm oranı; 1 kg tavuk eti üretebilmek için kullanılan yem miktarını ifade etmektedir.</p>
          
          <img 
            src='${resim1}' 
            alt="Performans Hesaplama"
            class="content-image"
          />
          
          <p>Yapılan analizler neticesinde kümesleri 4 grupta izlemek mümkündür.</p>
          
          <img 
            src='${resim2}' 
            alt="Performans Grupları"
            class="content-image"
          />
          
          <p><strong>Sonuç Olarak;</strong></p>
          
          <p>Sonuç Olarak;

Yetiştiricilerin kümesleri birbirine benzer teknolojik ekipmanlara sahiptir. Aynı damızlık ırktan gelen hayvanlar ile üretime başlamalarına, aynı yem, veterinerlik hizmetleri ve aşılama faaliyetleri olmasına rağmen performans puanları %24 oranında farklılık göstermektedir. Bu duruma direkt olarak, bakım kusurlarının neden olduğu varsayımına ulaşılmıştır. En kötü performans sağlayan kümesin maliyetler düşüldükten sonra elde edeceği net kar ile en iyi kümesin karlılığı arasında %866 oranında farklılık vardır. Bu gerekçeler ile bakım kusurlarının ortadan kaldırılmasına yönelik sistem kullanılması, tüm yetiştiricilere önerilmektedir.</p>
        </div>
      `
    },
    {
      id: 'maliyet',
      title: 'Maliyet Hesaplamaları',
      icon: maliyetIcon,
      content: `
        <div class="maliyet-content">
          <p>Kümeslerin maliyetleri 2 ana başlık altına toplanmıştır:</p>

          <div class="maliyet-group">
            <h3>1. Yatırım Maliyetleri</h3>
            <p>Kümesle alakalı yapılan ödeme birden fazla dönemi ilgilendiriyor ise bu ödeme yatırım maliyeti olarak sisteme işlenmelidir. Örneğin kümes onarımları ile ilgili maliyetler, o dönem yetiştirilen ürünle ilgili değil, birden fazla dönemi etkileyen durumlardır. Bu maliyetler için amortisman süresi girilmelidir. Girilen amortisman süresine göre maliyet takip eden dönemlere de yansıtılarak hesaplanacaktır.</p>
          </div>

          <div class="maliyet-group">
            <h3>2. Dönemlik Maliyetler</h3>
            <p>Yapılan bir ödeme direkt olarak o dönem yetiştirilen hayvanlarla ilgili ise dönemlik maliyet olarak sisteme işlenmelidir. Örneğin altlık maliyetleri vb. gibi.</p>
          </div>
        </div>
      `
    },
    {
      id: 'sensor',
      title: 'Sensör Verileri',
      icon: sensorIcon,
      content: `
        <div class="sensor-content">
          <p>eKümes WEB tabanlı bir uygulamadır. Sistemin kullanılabilmesi için bilgisayar satın alınmasına gerek yoktur. Web ara yüzü ile kullanılabileceği gibi android ve ios cep telefonlarına da uygulama olarak yüklenebilir. Bu sayede, internet olan her ortamdan ulaşılabilir.</p>

          <p>Kümeslerden sensör verilerini toplamak için 3 farklı ünite bulunmaktadır. Toplanan veriler sunucu üzerinden takip edilerek analiz edilmektedir.</p>

          <p>eKümes sisteminin tüm kart tasarımları ve montajı firmamız tarafından yapılmaktadır.</p>

          <img 
            src='${resim3}' 
            alt="Sensör Sistemi"
            class="content-image"
          />

          <div class="sensor-units">
            <div class="sensor-unit">
              <h3>1. Cihaz Veri Toplama Ünitesi</h3>
              <p>Dış Ortam Sıcaklık Sensörü, Dış Ortam Nem Sensörü, Dış Ortam Hava Basıncı Sensörü, Açık Kontak (Pano Arızası), Fan durumu ve arızası, Elektrik Kesintisi – Jeneratör Arızası gibi bilgileri toplar. 2 adet Cihaz sensör ünitelerinden ve maksimum 12 adet olmak üzere fan sensörlerinden gelen verileri alarak GSM (turkcel, vodafone, TürkTelekom) veri hattı ile sunucuya göndermektedir.</p>
            </div>

            <div class="sensor-unit">
              <h3>2. Cihaz Sensör Ünitesi</h3>
              <p>İç Ortam Sıcaklık Sensörü, İç Ortam Nem Sensörü, İç Ortam Hava Basıncı Sensörü, tVOC Gaz sensörü içermektedir. Sistemin çalışma prensibi Resim 2'de gösterilmiştir.</p>
            </div>

            <div class="sensor-unit">
              <h3>3. Fan Sensörü</h3>
              <p>Fanların bulunduğu yerde elektrik kablosunun etrafına plastik aparat ile takılan ve elektrik amperini okuyarak fanın dönme hızını hesaplayan sensörler mevcuttur. Bilgileri radyo dalgası ile cihaz veri toplama ünitesine aktarmaktadır. Hiçbir kablo bağlantısı gerektirmez.</p>
            </div>
          </div>

          <img 
            src='${resim4}' 
            alt="Sensör Çalışma Prensibi"
            class="content-image"
          />
        </div>
      `
    },
    {
      id: 'uyari',
      title: 'Sistem Uyarıları',
      icon: uyariIcon,
      content: `
        <div class="uyari-content">
          <p>eKümes kullanıcılar tarafından girilen verilerini ve kümeslerden her 5 dakikalık periyotlarla toplanan sensör verilerini sunucu üzerine kaydettikten sonra Yapay zeka yazılımları ile analiz etmektedir. Kaydedilen verilerin dönem performansına olumsuz etkisi olacağı hesaplanırsa, kümesin bakıcısına ve kümesin sahibine bildirimler göndermektedir.</p>

          <p>Kümeste ortaya çıkan sorun anlık çözülmesi gereken bir problem ise, otomatik olarak SMS yoluyla ve/veya sesli operatör mesajı ile uyarı üretmektedir. Örneğin elektrik kesintisi olmuş ve jeneratör devreye girmemiş ise bu duruma hemen müdahale edilmesini sağlamak için uyarı sistemi devreye girmektedir.</p>

          <p>Sistemin ürettiği tüm uyarılar eKümes sistemi içerisinden izlenmektedir.</p>
        </div>
      `
    },
    {
      id: 'limit',
      title: 'Kümes Limitleri',
      icon: kumesLimitIcon,
      content: `
        <div class="limit-content">
          <p>eKümes sınırsız sayıda üretici ve her üretici için sınırsız sayıda kümes tanımlanmasına olanak sağlamaktadır. Sunucularımız bulut tabanında 1000 Mb. upload ve download hızında veri işleme kapasitesine sahiptir.</p>
        
          <img 
            src='${resim5}' 
            alt="Kümes Limitleri"
            class="content-image"
          />
        </div>
      `
    },
    {
      id: 'ucret',
      title: 'Ücretlendirme',
      icon: ucretIcon,
      content: `
        <div class="ucret-content">
          <p>Ücretlendirme için 3 paket mevcuttur. Paket detayları ve ücretleri ekumes.com.tr internet sitemizde verilmiştir.</p>

          <div class="ucret-info">
            <h3>Ödeme Sistemi</h3>
            <p>Ücretsiz deneme süresi sonunda yazılım içerisinde hesabım başlığı adında üretici için kaç adet kümes tanımlanmış ise birim fiyat ile çarpılarak aylık bir fatura üretilmektedir.</p>
            
            <h3>Ödeme Seçenekleri</h3>
            <ul>
              <li>Kredi kartı ile ödeme</li>
              <li>eFatura numarasını açıklama alanına yazıp havale/EFT</li>
            </ul>

            <div class="note-box">
              <p>Banka hesabımız ile eKümes sistemi arasında otomatik entegrasyon mevcuttur. Yapılan ödeme ya da EFT en geç 10 dakika içerisinde sisteme otomatik olarak yansıtılmaktadır.</p>
            </div>

            <div class="warning-box">
              <h4>Önemli Bilgilendirme</h4>
              <ul>
                <li>Fatura ödeme vadesi 10 gün ile sınırlıdır.</li>
                <li>10 gün içerisinde faturanın ödenmemesi durumunda kullanıcı hesaplarınız dondurulur.</li>
                <li>Adınıza kayıtlı veriler 90 gün süresince sunucularımızda tutulmaya devem eder.</li>
                <li>90 gün içerisinde ödeme yapılmaması durumunda size ait veriler, Kişisel verilerin Korunumu kanununa göre geri dönüşümsüz olarak silinecektir.</li>
                <li>90 gün sonrasında tekrar sistemi kullanmak isterseniz yeniden hesap oluşturmanız gerekecektir.</li>
              </ul>
            </div>
          </div>
        </div>
      `
    },
    {
      id: 'tanimlama',
      title: 'Sabit Tanımlamalar',
      icon: tanimlamaIcon,
      content: `
        <div class="tanimlama-content">
          <p>Sistemde sabit tanımlamalar eksik olduğunda veya yeni bir tanımlama gerektiğinde yapmanız gerekenler:</p>

          <div class="tanimlama-steps">
            <div class="step">
              <h3>1. Sabit Tanımlamaları Kontrol Edin</h3>
              <p>Sistemde Ayarlar > Sabit Tanımlamalar menüsünden mevcut tanımlamaları kontrol edin.</p>
            </div>

            <div class="step">
              <h3>2. Eksik Tanımlamaları Belirleyin</h3>
              <p>İhtiyacınız olan ancak listede bulunmayan tanımlamaları not edin.</p>
            </div>

            <div class="step">
              <h3>3. Destek Ekibine Bildirin</h3>
              <p>Eksik tanımlamaları support@ekumes.com adresine mail atarak veya sistem içi mesajlaşma modülünü kullanarak destek ekibimize bildirin.</p>
            </div>

            <div class="note-box">
              <p>Not: Yeni tanımlamalar, sisteme en geç 24 saat içerisinde eklenmektedir.</p>
            </div>
          </div>
        </div>
      `
    }
  ];

  return (
    <div className="sss-container">
      <div className="icon-grid">
        {sections.map((section, index) => (
          <div
            key={section.id}
            className={`icon-box ${activeSection === section.id ? 'active' : ''}`}
            onClick={() => setActiveSection(section.id)}
          >
            <img src={section.icon} alt={section.title} className="section-icon" />
            <p className="icon-label">{section.title}</p>
          </div>
        ))}
      </div>

      <div className="content-area">
        {sections.map((section) => (
          activeSection === section.id && (
            <div key={section.id} className="content-section">
              <h2>{section.title}</h2>
              <div dangerouslySetInnerHTML={{ __html: section.content }} />
            </div>
          )
        ))}
      </div>
    </div>
  );
};



export default SSS;
